
import Container from '@/components/container';
import Content from '@/components/content';
import Range from '@/components/range';
import Title from '@/components/title';

/**
 * @component SliderComponent
 *
 * @prop {String} title
 * @prop {Number} value
 * @prop {Number} min
 * @prop {Number} max
 * @prop {Number} ratio
 * @prop {String} unit
 * @public
 */

export default {
  name: 'SliderComponent',
  components: {
    Range,
    Container,
    Content,
    Title,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    ratio: {
      type: Number,
      default: 1,
    },
    unit: {
      type: String,
      default: '$',
    },
  },
  computed: {
    /**
     * Returns an approximation based on slider value.
     *
     * @return {String}
     * @private
     */

    estimate() {
      return this.format(this.value);
    },
  },
  methods: {
    /**
     * Transform value into something humans can read (based on given unit).
     *
     * @param {Number} value
     * @return {String}
     * @private
     */

    format(value) {
      const { unit } = this;
      if (unit === '$') {
        return `$${this.currency(value)}`;
      }
      return `${value}%`;
    },

    /**
     * Format currency.
     *
     * Examples:
     *
     *   currency(800000)
     *   // => 800k
     *   currency(2530000)
     *   // => 2.53M
     *
     *
     * @param {Number} value
     * @return {String}
     * @private
     */

    currency(value) {
      if (value < 1000000) {
        return `${Math.round(value / 1000)}K`;
      }
      const millions = value / 1000000;
      return `${millions.toFixed(millions % 1 === 0 ? 0 : 3)}M`;
    },

    /**
     * Emit value change event.
     *
     * @private
     */

    change(...args) {
      this.$emit('change', ...args);
    },
  },
};
